// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__jnuXW","vLegacy":"SelectSecondary_vLegacy__Zn7WO","error":"SelectSecondary_error__13vug","disabled":"SelectSecondary_disabled__1henK"};